import { render, staticRenderFns } from "./formTitle.vue?vue&type=template&id=6c787fb3&scoped=true"
import script from "./formTitle.vue?vue&type=script&lang=js"
export * from "./formTitle.vue?vue&type=script&lang=js"
import style0 from "./formTitle.vue?vue&type=style&index=0&id=6c787fb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c787fb3",
  null
  
)

export default component.exports